function thumbnailChange() {
    // Handle all media types (image, video, model) and AB test versions
    $(".product-thumbnails [class*='thumbnail--media-']").on( "click", function(e) {
        e.preventDefault();
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected");
        const mediaId = $(this).attr("data-media-id");
        
        // Find the active slideshow (version A or version B)
        var $activeSlideshow = $('.version-a:not(.hidden-i) .slick-slider, .version-b:not(.hidden-i) .slick-slider');
        if ($activeSlideshow.length === 0) {
            // Fallback for non-AB test products
            $activeSlideshow = $('.slick-slider');
        }
        
        var slideIndex = $activeSlideshow.find('[data-media-id="' + mediaId + '"]').closest('.slick-slide').data('slick-index');
        $activeSlideshow.slick('slickGoTo', slideIndex);
    });  
}

window.activateABTest = function() {
    console.log('activateABTest');
    $('.version-b').removeClass('hidden-i');
    $('.version-a').addClass('hidden-i');
    
    // Reinitialize Slick sliders for version B
    setTimeout(function() {
        // Destroy existing sliders in version A
        $('.version-a .product-slideshow').slick('unslick');
        $('.version-a .product-thumbnails').slick('unslick');
        
        // Initialize sliders for version B
        $('.version-b .product-slideshow').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            speed: 500,
            cssEase: 'linear',
            adaptiveHeight: true,
            pauseOnHover: true,
            initialSlide: 0,
            asNavFor: '.version-b .product-thumbnails',
            prevArrow: '<button type="button" class="slick-product-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
            nextArrow: '<button type="button" class="slick-product-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
        });
        
        $('.version-b .product-thumbnails').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.version-b .product-slideshow',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false
        });
        
        // Reinitialize thumbnail click handlers
        $('.version-b .product-thumbnails a').off('click');
        thumbnailChange();
    }, 100);
}